<template>
  <div class="allcom">
<!--    <div class="banner"></div>-->
    <div class="main-con">
      <div class="comp">我的项目</div>
      <div class="filter-con">
        <div class="left">
          <div :class="{ active: iscur === 2 }" @click="butlisttwo">
            最近创建
          </div>
          <div :class="{ active: iscur === 1 }" @click="butlist">全部项目</div>
        </div>
        <div class="right">
          <div class="search">
            <div>
              <el-date-picker
                v-model="timeDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="medium "
                >
              </el-date-picker>

            </div>
            <div class="input-con">
              <el-input
                v-model="searchText"
                @change="getsearch"
                placeholder="搜索项目名称|搜索客户名称"
                type="text"
                size="medium"
              />
            </div>
            <div>
              <el-button type="danger" @click="getsearch" icon="el-icon-search" size="medium">搜索</el-button>
              <el-button @click="getDelete" icon="el-icon-delete" size="medium">清空</el-button>
            </div>
          </div>
          <div class="card" style="margin-left: 24px" @click="gocard">
            <img :src="cardImg" />
          </div>
          <div class="list" style="margin-left: 8px" @click="golist">
            <img :src="imgList">
          </div>
        </div>
      </div>
      <div class="list-con">
        <div class="list" v-if="num===1">
          <div
            class="item"
            :key="'list_item_' + index"
            v-for="(item, index) in newlist"
          >
            <div
              class="img"
              :style="{
                background: `url('${item.coverUrl}') no-repeat center center /100% auto`
              }"
              @click="golink(item.id)"></div>
            <div class="info">
              <div class="title" @click="golink(item.id)">{{ item.projectName }}</div>
              <div class="desc">
                <div class="user">{{ item.customerName }}</div>
                <div style="display: flex;justify-content: space-between">
                  <div class="time">创建于&nbsp;{{item.editTime | dateFormatter}}</div>
                  <div @click="goDelete(item.id)" v-show="!item.canDelete" style="cursor: pointer">
                      <i class="el-icon-delete"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <el-table
          :data="newlist"
          class="table">
            <el-table-column label="封面图" width="150">
              <template slot-scope="scope">
                <div class="table_name" @click="golink(scope.row.id)">
                  <img :src="scope.row.coverUrl" style="width: 142px;height: 80px" />
<!--                  <div>{{ scope.row.projectName }}</div>-->
                </div>
              </template>
            </el-table-column>
            <el-table-column label="项目名称" width="300">
              <template slot-scope="scope">
                <div class="table_name" @click="golink(scope.row.id)">
                  <!--                  <img :src="scope.row.coverUrl" style="width: 142px;height: 80px" />-->
                  <div>{{ scope.row.projectName }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="客户名称" prop="customerName"></el-table-column>
            <el-table-column label="创建时间">
              <template slot-scope="scope">
                {{scope.row.editTime | dateFormatter}}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span class="but" style="color: #606266;cursor: pointer" type="text" @click="goDelete(scope.row.id)" v-show="!scope.row.canDelete">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="newlist.length == 0" class="loading">暂无任何数据</div>
        <div v-else>
          <div v-if="nomore" class="loading">已经到达最底部</div>
          <div v-else class="loading">加载中...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import moment from "moment";
import { detailsDelete } from '@/api/projectManage'
export default {
  name: 'Allcom',
  data() {
    return {
      iscur: 2,
      alllist: [],
      alllist_two: [],
      newlist: [],
      nomore: false,
      loadinng: false,
      pageNum: 1,
      totalPages: 0,
      searchText: '',
      cardImg:require('../../assets/imgs/icon_card_click@2x.png'),
      imgList:require('../../assets/imgs/icon_list_default@2x.png'),
      num:1,
      timeDate:[],
      startTime: '',
      endTime: ''
    }
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  },
  beforeCreate() {
    document.body.setAttribute('style', 'background:#ffffff;')
  },
  methods: {
    ...mapMutations(['changeMenuStatus']),
    goDelete(id) {
      this.$confirm('此操作将永久删除该项目信息及项目相关文档，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((val) => {
        console.log(val)
        detailsDelete(id).then(res => {
          this.$message.success('删除成功')
          this.getsearch()
        })
      }).catch((err) => {
        console.log(err)
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    getDelete() {
      this.iscur = 2
      this.timeDate = []
      this.searchText = ''
      this.getnum()
    },
    gocard(){
      this.cardImg = require('../../assets/imgs/icon_card_click@2x.png')
      this.imgList = require('../../assets/imgs/icon_list_default@2x.png')
      this.num = 1
    },
    golist(){
      this.cardImg = require('../../assets/imgs/icon_card_default@2x.png')
      this.imgList = require('../../assets/imgs/icon_list_click@2x.png')
      this.num = 2
    },
    handleSearch() {
      this.pageNum = 1
      this.getmore()
    },
    //全部商机
    butlist() {
      this.newlist = []
      this.pageNum = 1
      this.iscur = 1
      this.getnum()
      window.addEventListener('scroll', this.handleScroll, true)
    },
    //最近创建
    butlisttwo() {
      this.iscur = 2
      this.newlist = []
      this.getmore()
    },
    //获取数据,全部商机
    getnum() {
      this.nomore = false
      this.loadinng = true
      if(this.timeDate.length){
        this.startTime = this.getTimeNum(this.timeDate[0])
        this.endTime = this.getTimeNum(this.timeDate[1])
      }else{
        this.startTime = ''
        this.endTime = ''
      }
      this.$request
        .getAllcom(this.pageNum, this.searchText, this.startTime, this.endTime)
        .then((res) => {
          if (res.code == 200) {
            if (this.pageNum == 1) {
              this.newlist = res.data.records
            } else {
              this.newlist = [...this.newlist, ...res.data.records]
            }
            this.totalPages = res.data.pages
            if (this.totalPages == this.pageNum) {
              this.nomore = true
            }
          }
        })
        .finally(() => {
          this.loadinng = false
        })
    },
    //获取数据,最近创建
    getmore() {
      if(this.timeDate.length){
        console.log(123)
        this.startTime = this.getTimeNum(this.timeDate[0])
        this.endTime = this.getTimeNum(this.timeDate[1])
      }else{
        this.startTime = ''
        this.endTime = ''
      }
      this.newlist = []
      this.nomore = true
      this.loadinng = true
      this.$request
        .getAllcommore(this.searchText, this.startTime, this.endTime)
        .then((res) => {
          if (res.code == 200 && this.iscur === 2) {
            this.newlist = res.data
          }
        })
        .finally(() => {
          this.loadinng = false
        })
    },
    getTimeNum(value){
      var data = new Date(value)
      var y = data.getFullYear()
      var m = data.getMonth()+1;
      var d = data.getDate();
      var h = data.getHours();
      var i = data.getMinutes();
      var s = data.getSeconds();
      if(m<10){
        m = '0'+ m
      }
      if(h<10){
        h = '0'+h
      }
      if(d<10){
        d = '0'+d
      }
      if(i<10){
        i = '0'+i
      }
      if(s<10){
        s = '0'+s
      }
      return y+'-'+m+'-'+d+' '+h+':'+i+':'+s
    },
    //搜索
    getsearch() {
      if(this.timeDate.length){
        this.startTime = this.getTimeNum(this.timeDate[0])
        this.endTime = this.getTimeNum(this.timeDate[1])
      }else{
        this.startTime = ''
        this.endTime = ''
      }
      this.nomore = true
      this.loadinng = true
      if (this.iscur == 1) {
        this.$request
          .getAllcom(1, this.searchText, this.startTime, this.endTime)
          .then((res) => {
            if (res.code == 200) {
              this.newlist = res.data.records
              this.searchText = ''
            }
          })
          .finally(() => {
            this.loadinng = false
          })
      } else {
        this.getmore()
      }
    },
    //判断划到底部是，页码加一
    handleScroll() {
      if (document.documentElement.scrollTop + window.innerHeight >= document.body.offsetHeight) {
        if (this.pageNum == this.totalPages || this.loadinng) {
          return
        }
        if(this.iscur = 1){
          this.pageNum++
          this.getnum()
        }
      }
    },
    // 点击项目跳转
    golink(id){
      this.$router.push({
        path: '/manage/doclist',
        query: {
          id: id
        }
      })
    }
  },
  mounted() {
    this.getmore()
    this.changeMenuStatus({ value: 3 })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
.but:hover{
  color: #e60027 !important;
}
.table_name{
  display: flex;
  justify-items: center;
  cursor: pointer;
  div{
    //line-height: 80px;
    margin-left: 8px;
  }
}
::v-deep .el-table td{
  border: none !important;
}
::v-deep .el-table th.is-leaf{
  border: none !important;
}
::v-deep .el-table--border::after, .el-table--group::after{
  width: 0;
}
::v-deep .el-table::before{
  width: 0;
}
::v-deep .el-table .el-table__fixed-right::before,.el-table__fixed::before{
  width: 0;
}
.card img, .list img{
  height: 32px;
  width: 32px;
  cursor: pointer;
  //background: url('~@/assets/imgs/icon_card_click@2x.png') no-repeat center
  //  center / 32px auto;
}
.allcom {
  .banner {
    height: 3.08rem;
    background: url('~@/assets/imgs/pic_business_bg@2x.png') no-repeat center
      center / 100% auto;
  }
  .loading {
    text-align: center;
    padding: 40px 0;
  }

  & > .main-con {
    width: 15.04rem;
    margin: 0 auto;
    min-width: 1000px;
    & > .comp {
      padding-top: 0.36rem;
      padding-bottom: 0.12rem;

      font-size: 24px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }

    & > .filter-con {
      display: flex;
      align-items: center;
      & > .left {
        flex: 0 0 1.76rem;
        display: flex;
        padding-top: 0.08rem;
        & > div {
          flex: 1;
          line-height: 0.32rem;
          height: 0.32rem;
          text-align: center;
          border: 1px solid #d9d9d9;
          position: relative;
          cursor: pointer;
          z-index: 22;
          &:last-child {
            margin-left: -1px;
          }
          &.active {
            border: 1px solid #e60027;
            z-index: 33;
            color: #e60027;
          }
        }
      }
      & > .right {
        display: flex;
        justify-content: flex-end;
        flex: 1;
        padding-right: .16rem;
        & > .search {
          display: flex;
          & > .input-con {
            display: flex;
            align-items: center;
            margin: 0 10px;
            width: 2.4rem;
            border-radius: 0.02rem;
            padding-right: 0.16rem;

            & > .btn {
              flex: 0 0 14px;
              height: 14px;
              background: url('~@/assets/imgs/icon_search@2x.png') no-repeat
                center center / 14px auto;
              cursor: pointer;
            }
          }
        }
      }
    }
    & > .list-con {
      margin-top: 16px;
      box-sizing: border-box;

      min-width: 1000px;
      & > .list {
        margin: 0 -0.15rem;
        display: flex;
        flex-wrap: wrap;
        & > .item {
          flex: 0 0 3.51rem;
          margin: 0.15rem;
          margin-bottom: 0.5rem;
          cursor: pointer;
          & > .img {
            height: 2.31rem;
            border-radius: 0.12rem;
            background-color: #ccc;
            border: 1px solid #eee;
            box-sizing: border-box;
            // background: url('~@/assets/imgs/item-bg.png') no-repeat center
            //   center / 100% auto;
            &.add {
              background: url('~@/assets/imgs/add-circle-fill@2x.png') no-repeat
                center center / 56px auto;
              background-color: #f0f0f0;
            }
          }

          & > .info {
            & > .title {
              padding-top: 0.12rem;
              color: rgba(0, 0, 0, 0.85);
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              font-weight: bold;
            }
            & > .desc {
              color: rgba(0, 0, 0, 0.45);
              align-items: center;
              height: 0.2rem;
              padding-top: 0.04rem;

              & > .user {
                flex: 0 0 auto;
              }
              & > .time {
                padding-top: 0.04rem;
                flex: 0 0 auto;
              }
            }
          }
        }
      }
    }
  }

  .p_one {
    font-size: 14px;
    margin: 12px 0px 0px 0px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .p_two {
    font-size: 12px;
    margin: 4px 0px;
    padding: 0;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 20px;
  }
  .loading {
    text-align: center;
    padding: 40px 0;
  }
}
</style>
